// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VrdFAvLvTDuEeWrvkDRw {
  width: 100%;
  display: flex;
  margin: 0 1px;
  position: relative;
  padding: 5px 0;
  align-items: center;
  box-sizing: border-box;
}

.NK9kWjMvZTofIIoU8juO {
  position: absolute;
  top: -0.2em;
  border: 1px solid var(--grey-color-70);
  background-color: var(--grey-gradient-start-color-10);
  border-radius: 1.2em;
  padding: 0.2em 0.8em;
  color: var(--grey-color-90);
  z-index: 1;
  text-align: center;
  font-size: clamp(0.7rem, 0.9vw, 0.85rem);
  height: auto;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.2;
}

.uDNng6VXeGZWBwFpLPzL {
  height: 8px;
  border-radius: 15px;
  border-top-left-radius: "8px";
  border-bottom-left-radius: "8px";
}

.KKUF7TNk8pfulUuxT0PG {
  height: 8px;
  border-radius: 15px;
  border: 1px solid var(--grey-color-60);
}

.R9wO65WQxxQZNtc2WVz_ {
  position: relative;
}

.NRJdw5c0TkqY4t5OaONN {
  position: absolute;
  top: 0;
  font-size: 3em;
  color: var(--grey-color-70);
}

.juxMRtn5RhRtlxolcCLE {
  display: flex;
  position: relative;
}

.Nhz_9rY8_C37QaoFtu5p {
  font-family: var(--font-stack-full-regular);
  font-size: 14px;
  line-height: 24px;
  color: var(--grey-color-70);
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/AverageScore/AverageScore.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,sCAAA;EACA,qDAAA;EACA,oBAAA;EACA,oBAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,2BAAA;AADF;;AAIA;EACE,aAAA;EACA,kBAAA;AADF;;AAIA;EACE,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;AADF","sourcesContent":[".boxContainer {\n  width: 100%;\n  display: flex;\n  margin: 0 1px;\n  position: relative;\n  padding: 5px 0;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.targetValueBox {\n  position: absolute;\n  top: -0.2em;\n  border: 1px solid var(--grey-color-70);\n  background-color: var(--grey-gradient-start-color-10);\n  border-radius: 1.2em;\n  padding: 0.2em 0.8em;\n  color: var(--grey-color-90);\n  z-index: 1;\n  text-align: center;\n  font-size: clamp(0.7rem, 0.9vw, 0.85rem);\n  height: auto;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 1.2;\n}\n\n.filledContainer {\n  height: 8px;\n  border-radius: 15px;\n  border-top-left-radius: \"8px\";\n  border-bottom-left-radius: \"8px\";\n}\n\n.emptyBorderContainer {\n  height: 8px;\n  border-radius: 15px;\n  border: 1px solid var(--grey-color-60);\n}\n\n.targetArrowContainer {\n  position: relative;\n  // height: 50px;\n  // padding-top: 15px;\n}\n\n.targetArrow {\n  position: absolute;\n  top: 0;\n  font-size: 3em;\n  color: var(--grey-color-70);\n}\n\n.boxesContainerMapping {\n  display: flex;\n  position: relative;\n}\n\n.averageScoreAboveBelowText {\n  font-family: var(--font-stack-full-regular);\n  font-size: 14px;\n  line-height: 24px;\n  color: var(--grey-color-70);\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxContainer": `VrdFAvLvTDuEeWrvkDRw`,
	"targetValueBox": `NK9kWjMvZTofIIoU8juO`,
	"filledContainer": `uDNng6VXeGZWBwFpLPzL`,
	"emptyBorderContainer": `KKUF7TNk8pfulUuxT0PG`,
	"targetArrowContainer": `R9wO65WQxxQZNtc2WVz_`,
	"targetArrow": `NRJdw5c0TkqY4t5OaONN`,
	"boxesContainerMapping": `juxMRtn5RhRtlxolcCLE`,
	"averageScoreAboveBelowText": `Nhz_9rY8_C37QaoFtu5p`
};
export default ___CSS_LOADER_EXPORT___;
